import { Box, styled } from '@mui/material';

const Wrapper = styled(Box)`
  width: 100%;
  display: flex;

  align-items: center;
  justify-content: center;

  margin-top: 3rem;
`;

export default Wrapper;
